import React from 'react';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
import Select from '@atlaskit/select';
import { N20 } from '@atlaskit/theme/colors';
import { DisplayMode } from '../../RenderForm';
import { ViewWrapper } from '../common/questionWrappers';
export const ViewUserPicker = ({
  id,
  isMulti,
  value,
  displayMode
}) => {
  if (displayMode === DisplayMode.Edit || displayMode === DisplayMode.Preview || displayMode === DisplayMode.Translate) {
    // This is a Disabled Select
    return /*#__PURE__*/React.createElement(Select, {
      id: id,
      value: value,
      isMulti: isMulti,
      isDisabled: true,
      styles: {
        control: base => ({
          ...base,
          backgroundColor: `var(--ds-background-accent-gray-subtlest, ${N20})`,
          borderColor: "var(--ds-border-disabled, #DFE1E6)",
          color: "var(--ds-text, #172B4D !important)"
        }),
        menu: base => ({
          ...base,
          color: "var(--ds-text-subtle, #172B4D)"
        })
      },
      isClearable: true,
      defaultOptions: true,
      placeholder: "",
      menuPosition: getBooleanFF('platform.proforma-fix-dropdown-menu_zk9t9') ? undefined : 'fixed'
    });
  }
  return /*#__PURE__*/React.createElement(ViewWrapper, null, value && value.map(item => item.label).join(', '));
};